export default __webpack_public_path__ + "static/media/alert.6f65c97c.mp3";